import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import apiService from './services/api';

const apiUrl = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:3001`;
apiService.setConfig({ apiUrl });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
